import { Injectable } from "@angular/core";
import { SUrlService } from "@senior-gestao-pessoas/angular-components";
import URLproperties from "../../../core/utils/url-base";

@Injectable()
export class AppointmentApiService {
	constructor(private urlService: SUrlService) {
	}

	parserParams(params: object) {
		let param: string;
		for (var [key, value] of Object.entries(params)) {
			if (!param) {
				param = "?";
			} else {
				param += "&";
			}

			param += key + "=" + value;
		}
		return param;
	}

	getAnalyticsTotalHoras(params: object): string {
		const queryParams = this.parserParams(params);
		return "GPO/api/analytics/total-horas" + queryParams;
	}

	getAnalyticsIncidentJustification(params: object): string {
		const queryParams = this.parserParams(params);
		return "GPO/api/analytics/justificativas-incidentes/totalizador" + queryParams;
	}

	getTimeAdjustmentPendency(params: object): string {
		const queryParams = this.parserParams(params);
		return "GPO/api/analytics/total-pendencias-acerto" + queryParams;
	}

	getTimeAdjustmentPendencyEmployee(employee: string, params: object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/total-pendencias-acerto/colaborador/${employee}${queryParams}`;
	}

	getAnalyticsIncidentMoreOccurrences(params : object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/incidentes/totalizador-incidente-competencia${queryParams}`;
    }

	getAnalyticsIncidentCompetenceSummary(params : object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/incidentes/totalizador-competencias${queryParams}`;
    }

	getCompensatoryTimeProjectionHours(params: object): string {
		const queryParams = this.parserParams(params);
		return "GPO/api/analytics/bancos-horas/projecoes" + queryParams;
	}

	getCompensatoryTimeBalanceEmployee(employee: string, params: object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/bancos-horas/colaborador/${employee}/totalizadores${queryParams}`;
	}

	getCompensatoryTimeBalanceManager(params: object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/bancos-horas/totalizadores${queryParams}`;
	}

	getCompensatoryTimeProjectionHoursComplete(params: object): string {
		const queryParams = this.parserParams(params);
		return "GPO/api/analytics/bancos-horas/projecoes/completa" + queryParams;
	}

	getCompensatoryTimeAccounts(employee: string, params: object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/colaboradores/${employee}/contas-bancos-horas/abertas` + queryParams;
	}


	getCompensatoryTimeBalance(params: object): string {
		const queryParams = this.parserParams(params);
		return `GPO/api/analytics/bancos-horas/saldo` + queryParams;
	}

	getAverageTime(params: object): string {
		const queryParams = this.parserParams(params);

		return "GPO/api/analytics/total-horas" + queryParams;
	}

	getAverageTimeDrill(perRef: string, type: string, employee: string): string {
		const params = ["perRef=" + perRef, "type=" + type, "portal=g7", "activeview=manager", "fromAnalytics=true"];
		let route = "/analytics/hours-detail";
		if (type === "AFASTAMENTO") {
			route = "/analytics/hours-detail-work-leave";
		}

		this.addEmployeeParam(params, employee);
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + route, ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}


	getIncidentJustificationEmployeeDrill(competence: string, status: number, employee: string): string {
		const params = ["perRef=" + competence, "status=" + status, "portal=g7&loadInitialPeriod=N", "fromAnalytics=true"];
		const route = "/incidents/employee-incident-management-drill/" + employee;

		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + route, ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}

	getIncidentJustificationManagerDrill(competence: string, status: number): string {
		const params = ["perRef=" + competence, "status=" + status, "portal=g7", "fromAnalytics=true"];
		const route = "/incidents/manager-incident-management" ;

		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + route, ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}

	getIncidentMoreOccurrencesManagerDrill(incidentCode: string, incidentDesc: string , competence: string, employee: string): string {
        const params = ["incident=" + incidentCode, "incidentDesc=" + incidentDesc,"employee=" + employee, "perRef=" + competence, "status=" + status, "portal=g7", "fromAnalytics=true"];
		const route = "/analytics/incidente-detail-incident" ;

		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + route, ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
    }

	getIncidentCompetenceSummaryManagerDrill(perRef: string, competence: string, employee: string): string {
		const params = ["perRef=" + perRef, "employee=" + employee, "perRef=" + perRef, "status=" + status, "portal=g7", "fromAnalytics=true"];
		const route = "/analytics/incident-details-competence-summary" ;

		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + route, ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
    }

	getHoursEmployeeDrill(perRef: string, employee: string): string {
		const params = ["perRef=" + perRef, "portal=g7", "fromAnalytics=true"];
		this.addEmployeeParam(params, employee);
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/analytics/hours-detail-employee", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}


	getTimeAdjustmentPendencyDrill(competence: string, type: string, employee: string): string {
		const params = ["perRef=" + competence, "type=" + type, "portal=g7", "activeview=manager", "fromAnalytics=true"];
		this.addEmployeeParam(params, employee);
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/analytics/time-adjustment-detail", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}


	getCompTimeEmployeeDetailsDrill(competence: string, compTime: string, employee: string): string {
		const params = ["perRef=" + competence, "compTime=" + compTime, "portal=g7", "fromAnalytics=true"];
		this.addEmployeeParam(params, employee);
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/analytics/comp-time-detail-employee", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}

	getCompTimeProjectionDrill(perRef: string, type: string, employee: string,showFinancialValues: boolean): string {
		const params = ["perRef=" + perRef, "type=" + type, "portal=g7", "showFinancialValues=" + (showFinancialValues ? 'S' : 'N'), "fromAnalytics=true"];
		this.addEmployeeParam(params, employee);
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/analytics/comp-time-detail", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}

	getTimeAdjustmentDrill(perRef: string, employee: string, state: string): string {
		const params = ["from=ANALYTICS", "competence=" + perRef, "state=" + state, "employee=" + employee, "portal=g7", "fromAnalytics=true"];
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/time-adjustment/redirect", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}


	getTodaysJourneyDrill(): string {
		const params = ["portal=g7", "fromAnalytics=true"];
		const url = this.urlService.buildNavigationUrl(encodeURIComponent(this.getFrontendURL()) + "/user/register/today-working", ...params);
		return this.getPlatformURL() + `?link=${url}` + `&withCredentials=true&helpUrl=http:%2F%2Fdocumentacao.senior.com.br%2Fgestao-de-pessoas-hcm%2F6.2.34%2F%23gestao-ponto%2Fnova-interface%2Fapuracao-do-ponto%2Fgestor-rh%2Fpainel.htm&r=2`;
	}

	addEmployeeParam(params: string[], employee: string) {
		if (employee) {
			params.push("employee=" + employee);
		}
	}


	getPlatformURL() {
		let url = URLproperties.getPlatformURL();

		if (url.endsWith("/")) {
			url = url.substring(0, url.length - 1);
		}

		return url + "/#";
	}

	getFrontendURL() {
		let url = URLproperties.getAppointmentData().frontendURL;

		if (url.endsWith("/")) {
			url = url.substring(0, url.length - 1);
		}

		return url;
	}

	getTodaysJorney(employeeNTN: string): string {
		return `GPO/api/calculo-apuracao/simular/${employeeNTN}`;
	}

	getProperties(): string {
		return `GPO/api/proprietaria`;
	}
}
